import { CREATEREQUESTTIMEOFF_SUCCESS, CREATEREQUESTTIMEOFF_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const createRequestTimeOffReducer = (state = initialState, action) => {
    switch (action.type) {
        case CREATEREQUESTTIMEOFF_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case CREATEREQUESTTIMEOFF_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default createRequestTimeOffReducer;
